import { forwardRef, ReactElement, Ref } from "react";
import { Box, HelpText, Label, Select } from "@twilio-paste/core";

import { constants, types } from "./definitions";

const CompositeSelect = forwardRef(
  (
    {
      children,
      id,
      errorText,
      hasHtmlInLabel,
      helpText,
      label,
      // Paste recommendation: https://paste.twilio.design/components/textarea/#positioning-form-fields
      marginBottom = "space80",
      onChange,
      required,
      value,
      width,
      ...rest
    }: types.CompositeSelectProps,
    ref: Ref<HTMLSelectElement>
  ): ReactElement => {
    const errorTextId =
      rest.hasError && rest.name
        ? `${rest.name}${constants.ERROR_TEXT_ID_TAG}`
        : "";
    const helpTextId =
      helpText && rest.name ? `${rest.name}${constants.HELP_TEXT_ID_TAG}` : "";

    const getDefaultErrorText = (): string =>
      `Please select a ${rest?.name || "value"}`;

    return (
      <Box marginBottom={marginBottom} width={width}>
        <Label htmlFor={id} required={required}>
          {hasHtmlInLabel ? (
            <span dangerouslySetInnerHTML={{ __html: label }} />
          ) : (
            label
          )}
        </Label>

        <Select
          aria-describedby={`${errorTextId} ${helpTextId}`}
          id={id}
          onChange={onChange}
          value={value}
          ref={ref}
          {...rest}
        >
          {children}
        </Select>

        {helpText && <HelpText id={helpTextId}>{helpText}</HelpText>}

        {rest.hasError && (
          <HelpText id={errorTextId} variant="error">
            {errorText || getDefaultErrorText()}
          </HelpText>
        )}
      </Box>
    );
  }
);

export default CompositeSelect;
